import { Suspense, lazy } from 'react'
import { Box } from '@mantine/core'

const Editor = lazy(() => import('@monaco-editor/react'))

interface SqlEditorProps {
  value: string
  onChange?: (value: string) => void
  height?: string
  readOnly?: boolean
}

export function SqlEditor({
  value,
  onChange,
  height = '300px',
  readOnly = false,
}: SqlEditorProps) {
  return (
    <Box style={{ border: '1px solid var(--mantine-color-gray-3)' }}>
      <Suspense
        fallback={
          <Box
            style={{
              height,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            Loading SQL editor…
          </Box>
        }
      >
        <Editor
          height={height}
          language="sql"
          value={value}
          onChange={(newValue) => onChange?.(newValue ?? '')}
          options={{
            minimap: { enabled: false },
            scrollBeyondLastLine: false,
            automaticLayout: true,
            fontFamily: 'monospace',
            fontSize: 13,
            lineNumbers: 'on',
            roundedSelection: false,
            readOnly,
            padding: { top: 8, bottom: 8 },
          }}
          theme="vs"
        />
      </Suspense>
    </Box>
  )
}
